if (!customElements.get('product-card-carousel')) {
  class ProductCardCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.slideCount = parseInt(this.dataset.slideCount) || 1;
    }

    connectedCallback() {
      if (this.slideCount <= 1) return;

      this.track = this.querySelector('.product-card-carousel__track');
      this.prevBtn = this.querySelector('.product-card-carousel__arrow--prev');
      this.nextBtn = this.querySelector('.product-card-carousel__arrow--next');

      // Arrow clicks — stopPropagation prevents the <a> from navigating
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goTo(this.currentSlide - 1);
      });
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goTo(this.currentSlide + 1);
      });

      // Touch/swipe support (mobile only)
      this._swipedThisTouch = false;
      this.track.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.onTouchMove(e), { passive: false });
      this.track.addEventListener('touchend', (e) => this.onTouchEnd(e), { passive: true });

      // After a swipe, block the resulting click on the <a> link
      const parentLink = this.closest('a');
      if (parentLink) {
        parentLink.addEventListener('click', (e) => {
          if (this._swipedThisTouch) {
            e.preventDefault();
            this._swipedThisTouch = false;
          }
        });
      }

      // Prevent native image drag on desktop
      this.querySelectorAll('img').forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      this.updateArrows();
    }

    goTo(index) {
      if (index < 0 || index >= this.slideCount) return;
      this.currentSlide = index;
      this.track.style.transform = `translateX(-${index * 100}%)`;
      this.updateArrows();
    }

    updateArrows() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentSlide === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentSlide === this.slideCount - 1;
    }

    onTouchStart(e) {
      this.isDragging = true;
      this._locked = false;
      this._swipedThisTouch = false;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.currentX = this.startX;
      this.track.classList.add('is-dragging');
    }

    onTouchMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.touches[0].clientX;
      const diffX = this.currentX - this.startX;
      const diffY = e.touches[0].clientY - this.startY;

      if (!this._locked && Math.abs(diffY) > Math.abs(diffX)) {
        this.isDragging = false;
        this.track.classList.remove('is-dragging');
        return;
      }
      this._locked = true;
      e.preventDefault();

      const offset = -(this.currentSlide * 100) + (diffX / this.offsetWidth) * 100;
      this.track.style.transform = `translateX(${offset}%)`;
    }

    onTouchEnd() {
      if (!this.isDragging) {
        this._locked = false;
        return;
      }
      this.isDragging = false;
      this._locked = false;
      this.track.classList.remove('is-dragging');

      const diffX = this.currentX - this.startX;
      const threshold = this.offsetWidth * 0.15;

      if (Math.abs(diffX) > 10) {
        this._swipedThisTouch = true;
      }

      if (diffX < -threshold && this.currentSlide < this.slideCount - 1) {
        this.goTo(this.currentSlide + 1);
      } else if (diffX > threshold && this.currentSlide > 0) {
        this.goTo(this.currentSlide - 1);
      } else {
        this.goTo(this.currentSlide);
      }
    }
  }

  customElements.define('product-card-carousel', ProductCardCarousel);
}
